const sanityCDNUrl = "https://cdn.sanity.io/images/pwmfmi47/production";

export const cdn = (src: string, height: number) =>
  `${sanityCDNUrl}/${src}?h=${height}`;
